import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";
import intl from "../../i18n/intl";
import { toast } from "react-toastify";
import { update } from "lodash";

// const initialState = {
//   data: [],
//   record: null,
//   requesting: false,
//   error: null,
//   action: null,
//   details: null,
//   categories: null,
// };

const initialState = {
  data: {
    list: [],
    totalCount: 0,
  },
  query: {
    pageNo: 1,
    pageSize: 50,
    sortBy: "desc",
    sortColumn: "createdOn",
    namePattern: "",
  },
  record: null,
  requesting: false,
  error: null,
  action: null,
  details: null,
  categories: null,
  updatedBasicInfo: null,
  UpdatedRecipantInfo: null,
};

const customIntl = intl();

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    listRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "list";
      state.record = null;
    },
    listSuccess: (state, action) => {
      state.data = action.payload.response;
      state.requesting = false;
      state.error = null;
    },
    listFail: (state, action) => {
      state.data = [];
      state.requesting = false;
      state.error = action.payload;
    },
    // setQuery: (state, action) => {
    //   state.query = {
    //     ...state.query,
    //     ...action.payload,
    //   };
    // },

//     setQuery: (state, action) => {
//   const newQuery = {
//     ...(state.query || {}),
//     ...action.payload,
//   };
//   state.query = newQuery; // ensures a new reference every time
// },

setQuery: (state, action) => {
  const newQuery = {
    pageNo: state?.query?.pageNo ?? 1,
    pageSize: state?.query?.pageSize ?? 50,
    sortBy: state?.query?.sortBy ?? "desc",
    sortColumn: state?.query?.sortColumn ?? "createdOn",
    namePattern: state?.query?.namePattern ?? "",
    ...action.payload, // merges new values
  };
  state.query = newQuery;
},


    // updateStatusRequest: (state, action) => {
    //   state.requesting = true;
    //   state.error = null;
    //   state.action = "update";
    //   const rec = state.data.find((r) => r.id === action.payload.id);
    //   if (rec) {
    //     rec.isEnabled = action.payload.status;
    //   }
    // },
    // updateStatusRequest: (state, action) => {
    //   state.requesting = true;
    //   state.error = null;
    //   state.action = "update";

    //   const { id, status } = action.payload;

    //   state.data = state.data.map((item) =>
    //     item.id === id ? { ...item, isEnabled: status } : item
    //   );
    // },
 updateStatusRequest: (state, action) => {
  state.requesting = true;
  state.error = null;
  state.action = "update";

  const { id, status } = action.payload;

  // Update the notification in place
  state.data = state.data.map((note) =>
    note.id === id ? { ...note, isEnabled: status } : note
  );
},
    updateStatusSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "enable_performed" }),
            object: customIntl.formatMessage({ id: "notification" }),
          }
        )
      );
    },
    updateDisabledStatusSuccess: (state, action) => {
      state.requesting = false;
      state.error = null;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "disable_performed" }),
            object: customIntl.formatMessage({ id: "notification" }),
          }
        )
      );
    },
    updateStatusFail: (state, action) => {
      state.requesting = false;
      state.error = action.payload;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },

    GetNotificationRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "GetNotificationById";
      state.details = null;
    },

    // The notification loaded by id or for the edit and clone screens. The
    // name check has its own answers below: this used to store an answer by
    // whichever request had started last, so a notification answered while
    // its name was being checked was lost (F-BUG-13), and a name check
    // answered after another request replaced the loaded notification.
    GetSuccess: (state, action) => {
      state.details = action.payload.response;
      state.error = null;
      state.requesting = false;
    },


    GetFailure : (state, action) => {
      state.requesting=false;
      state.error=action.payload;
      state.details=null;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },

    updateNotificationContentRequest : (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "UpdateNotification";
      state.record = null;
    },




    updateNotificationContentSuccess : (state, action) => {
      state.record = action.payload.response;
      state.error = null;
      state.requesting = false;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "notification" }),
          }
        )
      );
    },

    updateNotificationContentFailure : (state, action) => {
      state.error = action.payload;
      state.requesting = false;
      if (action.payload.response === "INVALID_TIMEZONE") {
        toast.error(customIntl.formatMessage({ id: "invalid_timezone_error" }));
      } else if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },

    updateNotiBasicInfo:(state,action)=>{

      state.requesting = true;
      state.error = null;
      state.action = "updateNotiBasicInfo";
      state.record = null;
    },

    updateNotiBasicInfoSuccess : (state, action) => {
      state.updatedBasicInfo = action.payload.response;
      state.error = null;
      state.requesting = false;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "notification" }),
          }
        )
      );
    },
    updateCustomNotiRecipant:(state,action)=>{
      state.requesting = true;
      state.error = null;
      state.action = "updateCustomNotiRecipant";
      state.record = null;
    },
    updateNotificationRecipantSuccsess:(state,action)=>{
      state.UpdatedRecipantInfo = action.payload.response;
      state.error = null;
      state.requesting = false;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "update_performed" }),
            object: customIntl.formatMessage({ id: "notification" }),
          }
        )
      );
    },

    GetContentRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "GetNotificationContentByKey";
      state.record = null;
    },

    GetContentSuccess: (state, action) => {
      state.record = action.payload.response;
      state.error = null;
      state.requesting = false;
    },

    GetContentFailure : (state, action) => {
      state.requesting=false;
      state.error=action.payload;
      state.record=null;
    },

    GetOthersCategoryRequest: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "GetOthersCategory";
      state.categories = null;
    },

    GetOthersCategorySuccess: (state, action) => {
      state.categories = action.payload.response;
      state.error = null;
      state.requesting = false;
    },

    GetOthersCategoryFailure : (state, action) => {
      state.requesting=false;
      state.error=action.payload;
      state.categories=null;
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }},

    CreateNotificationContentRequest : (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "CreateNotification";
      state.record = null;
    },

    CreateNotificationContentSuccess : (state, action) => {
      state.record = action.payload;
      state.error = null;
      state.requesting = false;
      toast.success(
        customIntl.formatMessage(
          { id: "action_success" },
          {
            action: customIntl.formatMessage({ id: "create_performed" }),
            object: customIntl.formatMessage({ id: "notification" }),
          }
        )
      );
    },

    CreateNotificationContentFailure : (state, action) => {
      state.error = action.payload;
      state.requesting = false;
      if (action.payload.response === "INVALID_TIMEZONE") {
        toast.error(customIntl.formatMessage({ id: "invalid_timezone_error" }));
      } else if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
     GetNotificationClone : (state, action) => {
      state.error = null;
      state.action = "GetNotificationClone";
      state.requesting = true;
      state.details = null;
    },
     NotificationAlreadyExist : (state, action) => {
      state.error = null;
      state.action = "NotificationAlreadyExist";
      state.requesting = true;
      state.notiStatus = { response: false };
    },
    // Payload: { notiStatus: <API answer> } (read as notiStatus.notiStatus).
    NotificationAlreadyExistSuccess: (state, action) => {
      state.notiStatus = action.payload;
      state.error = null;
      state.requesting = false;
    },
    // A failed name check says nothing about the name; the loaded
    // notification stays.
    NotificationAlreadyExistFailure: (state, action) => {
      state.notiStatus = { response: false };
      state.requesting = false;
      if (action.payload?.status !== 400 && action.payload?.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },
    ResetNotificationStatus: (state) => {
  state.notiStatus = { response: false };
  state.requesting = false;
},
GetNotificationLogs: (state, action) => {
      state.requesting = true;
      state.error = null;
      state.action = "list";
      state.record = null;
    },
GetNotificationLogsSuccess: (state, action) => {
    const apiData = action.payload;
      const listData = apiData?.response?.list || apiData?.response || [];
      // state.data = action.payload; // ✅ store the full response object
      state.data = {
    list:  listData,      //apiData.response || [],
    // totalCount: apiData.response?.length || 0,
    status: apiData.status,
    code: apiData.code,
    success: apiData.success,

     totalCount: apiData?.response?.totalCount || 0,
      currentPage: apiData?.response?.currentPage || 1,
      totalPages: apiData?.response?.totalPages || 1,
      pageSize: apiData?.response?.pageSize || 50,
      sortBy: apiData?.response?.sortBy || "desc",
      sortColumn: apiData?.response?.sortColumn || "createdOn",
  };
      state.requesting = false;
      state.error = null;
    },
    GetNotificationLogsFailure: (state, action) => {
      state.data = [];
      state.requesting = false;
      state.error = action.payload;
    },
    notificationExportRequest: (state, action) => { },
    notificationExportSuccess: (state, action) => { },
    notificationExportFail: (state, action) => {
      if (action.payload.status !== 400 && action.payload.status !== 401) {
        toast.error(customIntl.formatMessage({ id: "something_else_wrong" }));
      }
    },

  },
});

export const {
  listFail,
  setQuery,
  listRequest,
  listSuccess,
  updateStatusFail,
  updateStatusRequest,
  updateStatusSuccess,
  updateDisabledStatusSuccess,
  GetNotificationRequest,
  GetFailure,
  GetSuccess,
  updateNotificationRecipantSuccsess,
  updateNotificationContentRequest,
  updateNotificationContentSuccess,
  updateNotificationContentFailure,
  GetContentRequest,
  GetContentSuccess,
  GetContentFailure,
  GetOthersCategoryRequest,
  GetOthersCategorySuccess,
  GetOthersCategoryFailure,
  CreateNotificationContentRequest,
  CreateNotificationContentSuccess,
  CreateNotificationContentFailure,
  GetNotificationClone,
  updateNotiBasicInfo,
  updateNotiBasicInfoSuccess,
  NotificationAlreadyExist,
  NotificationAlreadyExistSuccess,
  NotificationAlreadyExistFailure,
  GetNotificationLogs,
  updateCustomNotiRecipant,
  GetNotificationLogsSuccess,
  GetNotificationLogsFailure,
  notificationExportRequest,
  notificationExportSuccess,
  notificationExportFail
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
